import { render, staticRenderFns } from "./DonutChart19.vue?vue&type=template&id=cbd4b05e&scoped=true"
import script from "./DonutChart19.vue?vue&type=script&lang=js"
export * from "./DonutChart19.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd4b05e",
  null
  
)

export default component.exports